import React, { useContext } from 'react';
import { Button, Modal, message } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import client from '@/lib/feathers';
import { GroupBuyingOrdersContext } from '../SettingAndManagement';
import type { OrderForTableReceive } from '../types';

interface CancelGroupOrderProps {
  order: OrderForTableReceive;
}

const CancelGroupOrder = ({ order }: CancelGroupOrderProps) => {
  const { updateGroupBuyingOrder } = useContext(GroupBuyingOrdersContext);

  const groupBuyingService = client.service('groupBuying');

  const confirmCancel = () => {
    Modal.confirm({
      title: '確定取消該團購嗎？',
      icon: <ExclamationCircleOutlined />,
      content: '取消後將無法復原!!',
      okText: '確定',
      cancelText: '取消',
      onOk: cancelGroupOrder,
      onCancel: (close) => close(),
    });
  };

  const cancelGroupOrder = async () => {
    await groupBuyingService.patch(order._id, { status: '已取消' });
    updateGroupBuyingOrder();
    message.success('團購取消成功!');
  };

  return (
    <Button
      type="primary"
      danger
      onClick={confirmCancel}
      disabled={order.status === '已取消'}
    >
      取消
    </Button>
  );
};

export default CancelGroupOrder;
